import { useSuiClient } from '@mysten/dapp-kit';
import { useEffect, useState } from 'react';

export const useIsBlack = (coinType: string) => {
  const [isBlack, setIsBlack] = useState(false);
  const client = useSuiClient();
  const getIsBlack = async () => {
    const coin = await client.getCoinMetadata({
      coinType: coinType,
    });

    if (coin && !!coin.id) {
      const result = await client.getObject({
        id: coin.id,
        options: {
          showPreviousTransaction: true,
        },
      });
      if (result.data?.previousTransaction) {
        const res = await client.getTransactionBlock({
          digest: result.data?.previousTransaction,
          options: {
            showObjectChanges: true,
          },
        });
        const finalResult = (res.objectChanges as { objectType: string }[])?.some(
          (item) => item.objectType === `0x2::coin::RegulatedCoinMetadata<${coinType}>`,
        );
        setIsBlack(finalResult);
      }
    }
  };

  useEffect(() => {
    coinType && getIsBlack();
  }, [coinType]);

  return isBlack;
};
